import { s } from "../../typography.module-Clhw1hCq.js";
const legacyTypoMapping = {
  workSansHeading40: s["work-sans-heading-40"],
  workSansHeading32: s["work-sans-heading-32"],
  workSansHeading28: s["work-sans-heading-28"],
  workSansHeading24: s["work-sans-heading-24"],
  workSansHeading20: s["work-sans-heading-20"],
  workSansHeading16: s["work-sans-heading-16"],
  workSans20Regular: s["work-sans-20-regular"],
  workSans20Medium: s["work-sans-20-medium"],
  workSans16Regular: s["work-sans-16-regular"],
  workSans16Medium: s["work-sans-16-medium"],
  workSans16Semibold: s["work-sans-16-semi-bold"],
  workSans14Regular: s["work-sans-14-regular"],
  workSans14Medium: s["work-sans-14-medium"],
  workSans14Semibold: s["work-sans-14-semi-bold"],
  workSans13Medium: s["work-sans-13-medium"],
  workSans13Semibold: s["work-sans-13-semi-bold"],
  workSans12Regular: s["work-sans-12-regular"],
  workSans12Medium: s["work-sans-12-medium"],
  workSans12Semibold: s["work-sans-12-semi-bold"],
  workSans10Regular: s["work-sans-10-regular"],
  workSans10Medium: s["work-sans-10-medium"],
  workSansUppercase14Regular: s["work-sans-uppercase-14-regular"],
  workSansUppercase14Medium: s["work-sans-uppercase-14-medium"],
  workSansUppercase12Medium: s["work-sans-uppercase-12-medium"],
  workSansUppercase12Semibold: s["work-sans-uppercase-12-semi-bold"],
  workSansUppercase9Semibold: s["work-sans-uppercase-9-semi-bold"],
  nkduyMonoNumerical32Medium: s["nkduy-mono-numerical-32-medium"],
  nkduyMonoNumerical24Regular: s["nkduy-mono-numerical-24-regular"],
  nkduyMonoNumerical20Regular: s["nkduy-mono-numerical-20-regular"],
  nkduyMonoNumerical16Regular: s["nkduy-mono-numerical-16-regular"],
  nkduyMonoNumerical16Medium: s["nkduy-mono-numerical-16-medium"],
  nkduyMonoNumerical16Bold: s["nkduy-mono-numerical-16-bold"],
  nkduyMonoNumerical14Medium: s["nkduy-mono-numerical-14-medium"],
  nkduyMonoNumerical14Semibold: s["nkduy-mono-numerical-14-semi-bold"],
  nkduyMonoNumerical14Bold: s["nkduy-mono-numerical-14-bold"],
  nkduyMonoNumerical13Medium: s["nkduy-mono-numerical-13-medium"],
  nkduyMonoNumerical13Semibold: s["nkduy-mono-numerical-13-semi-bold"],
  nkduyMonoNumerical13Bold: s["nkduy-mono-numerical-13-bold"],
  nkduyMonoNumerical12Semibold: s["nkduy-mono-numerical-12-semi-bold"],
  nkduyMonoNumerical12Bold: s["nkduy-mono-numerical-12-bold"],
  nkduyMonoNumerical10Bold: s["nkduy-mono-numerical-10-bold"]
};
export {
  legacyTypoMapping
};
